import { createFileRoute } from "@tanstack/react-router";
import StoryPage, { type StoryCopy } from "@/components/StoryPage";
import { pageHead } from "@/lib/page-schema";
import { STORY_EN, storyAlternates, storyScripts } from "@/lib/story-schema";

const TITLE = "Our Story | A Colombian-Owned, Family-Run Limousine Company in Atlanta";
const DESC =
  "Meet Maria Priestly, the Colombian founder and owner of Empress Elite Limousine and Atlanta Luxury Sprinters, a small, family-owned, female-owned and Latina-owned company.";

const copy: StoryCopy = {
  lang: "en",
  toggle: { to: "/es/nuestra-historia", label: "Español" },
  eyebrow: "Hispanic Heritage Month",
  h1: "A Colombian-owned, family-run limousine company in Atlanta",
  intro:
    "Empress Elite Limousine and Atlanta Luxury Sprinters is a small, family-owned boutique company. We are female-owned and Latina-owned, founded and run by Maria Priestly.",
  imgAlt: "Maria Priestly, Colombian founder and owner of Empress Elite Limousine in Atlanta",
  sections: [
    {
      title: "Who Maria Is",
      body: [
        "Maria Priestly is Colombian, Latina, and the founder and owner of the company.",
      ],
    },
    {
      title: "A Family Business",
      body: [
        "We are not a national network or a booking app. We are a small family company, and our chauffeurs are long-tenured with us. Many of our clients have known the same faces for years.",
      ],
    },
    {
      title: "Why Family Ownership Matters to You",
      body: [
        "When your name is on the company, every ride is personal. Maria stands behind every booking herself. That is why we own every vehicle in our fleet.",
        "The vehicle and chauffeur you book should be the ones that show up.",
      ],
    },
  ],
  standardLink: { lead: "Want to know exactly what that means for your booking?", label: "Read the Empress Elite Standard." },
  ctaTitle: "Ride With Us",
  ctaBody: "Rated 5.0 on Google with 337 reviews. Call or text (678) 431-7222, or send your plans below.",
  callLabel: "Call (678) 431-7222",
};

export const Route = createFileRoute("/our-story")({
  head: () =>
    pageHead({
      path: "/our-story",
      title: TITLE,
      description: DESC,
      links: storyAlternates,
      scripts: storyScripts({
        url: STORY_EN,
        name: TITLE,
        description: DESC,
        inLanguage: "en-US",
        crumbs: [
          { name: "Home", path: "/" },
          { name: "Our Story", path: "/our-story" },
        ],
      }),
    }),
  component: () => <StoryPage c={copy} />,
});
